export default {
  apiUrl: process.env.VUE_APP_API_URL,
  apiEndpoints: {
    carModels: '/brand:A/car',
    // user auth
    login: '/user/login/email',
    loginGoogle: '/user/login/google',
    loginFacebook: '/user/login/facebook',
    newAccount: '/user/register',
    // user info
    userInfo: '/user/info', // GET
    updateUserInfo: '/user/info', // POST
    // user partner
    favouritePartner: '/user/partner:id', // POST
    deletePartner: '/user/partner', // DELETE
    deleteUser: '/user/delete',
    // user cars
    userCars: '/user/car', // GET - returns array of all cars or if car id specified (/user/car:1) returns single car data
    updateUserCars: '/user/car', // POST
    deleteCar: '/user/car:id', // DELETE
    // service stations
    serviceStations: '/brand:A/partner',
    // car service
    carServices: '/car:id/service',
    availablePartnerDates: '/partner:id/slot',
    newVisit: '/visit', // PUT
    cancelVisit: '/visit', // POST
    // pass recovery
    passToken: '/user/verify', // GET
    changePass: '/user/verify', // POST
    passRecovery: '/user/recover', // send email to get pass change link
    userActivation: '/user/activation',
    // get background
    background: '/brand:A',
  },
  google: {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  },
  facebook: {
    appId: process.env.VUE_APP_FACEBOOK_APP_ID,
  },
};
